var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',_vm._b({attrs:{"type":"danger","plain":"","icon":"el-icon-delete","size":_vm.size,"loading":_vm.isLoading},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteAction.apply(null, arguments)}}},'ElButton',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }